import { ActionError } from "@/ErrorHandling/types";

export const raiseCustomError = (msg: string, error_title?: string, cancel_button?: string) => {
  throw {
    status: "CUSTOM_ERROR",
    msg,
    refetchable: false,
    error_title,
    cancel_button,
  } as ActionError;
};

export const PermissionMapping = {
  sme_user: "SME_users",
  super_admin: "super_admins",
  data_provider: "data_providers",
  reviewer: "reviewers",
  corporate_coordinator: "corporate_coordinators",
  site_coordinator: "site_coordinators",
  organisation_admin: "organisation_admins",
  verifier: "verifiers",
};
export type Permission = keyof typeof PermissionMapping;
export const GroupToPermissionMapping = {
  SME_users: "sme_user",
  super_admins: "super_admin",
  data_providers: "data_provider",
  reviewers: "reviewer",
  corporate_coordinators: "corporate_coordinator",
  site_coordinators: "site_coordinator",
  organisation_admins: "organisation_admin",
  verifiers: "verifier",
} as const;
export type Group = keyof typeof GroupToPermissionMapping;

export const DisplayNameMapping: Record<string, string> = {
  SME_users: "SME User",
  super_admins: "Super Admin",
  data_providers: "Data Provider",
  reviewers: "Reviewer",
  corporate_coordinators: "Corporate Coordinator",
  site_coordinators: "Site Coordinator",
  organisation_admins: "Admin",
  verifiers: "Verifier",
};
